import { brand } from '../brand/brand';

// Цвета бренда (cameo, armadillo, rowYellowBG) берутся из палитры сборки:
// DOSCAR по умолчанию, Horizon для Rox и JetQ (REACT_APP_BRAND=horizon).
export const colors = {
  lightGrey: '#BABABA',
  cameo: brand.primary,
  dimGray: '#6A6A6A',
  blackPearl: '#05141F',
  alto: '#D9D9D9',
  white: '#FFFFFF',
  armadillo: brand.dark,
  backgroung: '#FBFBFB',
  disabled: '#ededed',
  statusGreen: '#71B183',
  rowRedBG: '#ff00001c',
  rowYellowBG: brand.row,
  red: '#EB5757',
  green: '#71B183',
  orange: '#FF8C00',
};
